import React from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';

import { FilestackImageWithTextData } from 'api/shared';
import Box from 'components/Box';
import Icon from 'components/Icon';
import { FilestackImage } from 'components/Image';
import Link from 'components/Link';
import NoAmp from 'containers/NoAmp';

import { showModal } from '../redux/main/actions/modal';
import { colors } from '../theme';

const List = styled.ul`
  display: flex;
  margin: -4px;
  flex-wrap: wrap;
  list-style-type: none;
  padding-left: 0;
  color: ${colors.greyishBrown};
  img {
    width: 100%;
    height: auto;
  }
  @media print {
    li {
      max-width: 100px;
    }
  }
`;
const MediaLink = styled(Link)`
  max-width: 100%;
`;
type OwnProps = {
  items: Array<FilestackImageWithTextData>;
};
type Props = OwnProps & {
  showModal: typeof showModal;
};
type State = {
  showAll: boolean;
};

class MediaGalleryContainer extends React.Component<Props, State> {
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/state-in-constructor
  state = {
    showAll: false,
  };

  setShowAll = (showAll: boolean) => {
    this.setState({
      showAll,
    });
  };

  showModal = (itemIndex: number) => {
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line react/destructuring-assignment
    this.props.showModal('MEDIA_GALLERY', {
      // TODO: Fix this the next time the file is edited.
      // eslint-disable-next-line react/destructuring-assignment
      items: this.props.items,
      itemIndex,
    });
  };

  render() {
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line react/destructuring-assignment
    const items = this.state.showAll
      ? // TODO: Fix this the next time the file is edited.
        // eslint-disable-next-line react/destructuring-assignment
        this.props.items
      : // TODO: Fix this the next time the file is edited.
        // eslint-disable-next-line react/destructuring-assignment
        this.props.items.slice(0, 4);
    return (
      <>
        <List>
          {items.map((item, index) => (
            <Box
              width={[1 / 2, 1 / 3, 1 / 4]}
              p="4px"
              key={item.fileId}
              component="li"
            >
              <MediaLink
                href="#"
                onClick={(ev) => {
                  ev.preventDefault();
                  this.showModal(index);
                }}
                data-qa-id="media-item"
              >
                <Box pb="100%" position="relative">
                  <Box position="absolute" width={1} top={0} left={0}>
                    <FilestackImage
                      data={item}
                      alt={item.altText || ''}
                      width={164}
                      height={164}
                      fit="crop"
                    />
                  </Box>
                </Box>
              </MediaLink>
            </Box>
          ))}
        </List>
        <NoAmp>
          {/* TODO: Fix this the next time the file is edited. */}
          {/* eslint-disable-next-line react/destructuring-assignment */}
          {this.props.items.length > 4 && (
            <Box mt={12} display="flex" alignItems="center">
              <Box width="16px" mr="6px">
                <Icon name="photo" fill={colors.greyishBrown} />
              </Box>
              {/* TODO: Fix this the next time the file is edited. */}
              {/* eslint-disable-next-line react/destructuring-assignment */}
              {this.state.showAll ? (
                // TODO: Fix this the next time the file is edited.
                // eslint-disable-next-line jsx-a11y/anchor-is-valid
                <Link
                  href="#"
                  onClick={(ev) => {
                    ev.preventDefault();
                    this.setShowAll(false);
                  }}
                  data-qa-id="view-less-photos"
                >
                  {getText('View fewer photos')}
                </Link>
              ) : (
                // TODO: Fix this the next time the file is edited.
                // eslint-disable-next-line jsx-a11y/anchor-is-valid
                <Link
                  href="#"
                  onClick={(ev) => {
                    ev.preventDefault();
                    this.setShowAll(true);
                  }}
                  data-qa-id="view-more-photos"
                >
                  {getText('View more photos')}
                </Link>
              )}
            </Box>
          )}
        </NoAmp>
      </>
    );
  }
}

// @ts-expect-error ts-migrate(2558) FIXME: Expected 5 type arguments, but got 6.
export default connect<Props, OwnProps, _, _, _, _>(null, {
  showModal,
})(MediaGalleryContainer);
